// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'building-3';

export const Component = () => (
  <g fill='none' stroke='currentColor'>
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M15.192 2.808v14.616M2.808 2.808h12.384M2.808 17.424V2.808m12.384 14.616H2.808M15.192 2.808H2.808L3.96.576h10.152zM.576 17.424h16.848m-6.768-1.656c0-.432-.144-.864-.504-1.224a1.737 1.737 0 0 0-1.224-.504c-.432 0-.864.144-1.224.504-.288.288-.504.72-.504 1.224v1.656h3.456z'
    />
    <path d='M5.616 5.328c.144 0 .288-.144.288-.288s-.144-.288-.288-.288-.288.144-.288.288.144.288.288.288zm3.384 0c.144 0 .288-.144.288-.288S9.144 4.752 9 4.752s-.288.144-.288.288.144.288.288.288zm3.384 0c.144 0 .288-.144.288-.288s-.144-.288-.288-.288-.288.144-.288.288.144.288.288.288zM5.616 8.712c.144 0 .288-.144.288-.288s-.144-.288-.288-.288-.288.144-.288.288.144.288.288.288zm3.384 0c.144 0 .288-.144.288-.288S9.144 8.136 9 8.136s-.288.144-.288.288.144.288.288.288zm3.384 0c.144 0 .288-.144.288-.288s-.144-.288-.288-.288-.288.144-.288.288.144.288.288.288zm-6.768 3.384c.144 0 .288-.144.288-.288s-.144-.288-.288-.288-.288.144-.288.288.144.288.288.288zm3.384 0c.144 0 .288-.144.288-.288S9.144 11.52 9 11.52s-.288.144-.288.288.144.288.288.288zm3.384 0c.144 0 .288-.144.288-.288s-.144-.288-.288-.288-.288.144-.288.288.144.288.288.288z' />
  </g>
);

export const viewBox = '0 0 18 18';
